import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, " Panel de instrucciones para el Personal ", -1)
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center gap-2 text-sm" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Comunidad:", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Block:", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", {
    class: "font-bold mb-4 mt-10 ml-4",
    style: {"text-align":"left"}
  }, " Panel de instrucciones para el Residente ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ComponentCard = _resolveComponent("ComponentCard")!

  return (_openBlock(), _createBlock(_component_ComponentCard, { class: "flex w-full p-7 mt-10" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCommunityId) = $event)),
              class: "border rounded px-2 py-1 text-sm"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.communities, (community) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: community.id,
                  value: community.id
                }, _toDisplayString(community.name), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [
                _vModelSelect,
                _ctx.selectedCommunityId,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("label", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBlockId) = $event)),
              class: "border rounded px-2 py-1 text-sm"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blocks, (block) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: block.id,
                  value: block.id
                }, _toDisplayString(block.name), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [
                _vModelSelect,
                _ctx.selectedBlockId,
                void 0,
                { number: true }
              ]
            ])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Accordion, {
        items: _ctx.formattedInstructionPersonal,
        multiple: true,
        editable: false,
        headerColor: 'bg-green-100',
        textColor: 'text-primary'
      }, null, 8, ["items"]),
      _hoisted_10,
      _createVNode(_component_Accordion, {
        class: "mt-5",
        items: _ctx.formattedInstructionResident,
        multiple: true,
        editable: false,
        headerColor: 'bg-green-100',
        textColor: 'text-primary'
      }, null, 8, ["items"])
    ]),
    _: 1
  }))
}